import { Container, Typography } from "@mui/material";
import React from "react";

export default function NoPlatform({ platform }) {
    return (
        <Container
            maxWidth="lg"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Typography variant="h1">
                Sorry, {platform} is not a platform that we support.
            </Typography>
        </Container>
    );
}
